var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { css } from 'styled-components';
import { Box } from '@vital-ui/react-utils';
export var InputWrapper = styled(Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  display: block;\n"], ["\n  position: relative;\n  display: block;\n"])));
export var IconButton = styled(Box)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  height: 100%;\n  width: 2rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: initial;\n  cursor: pointer;\n"], ["\n  height: 100%;\n  width: 2rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: initial;\n  cursor: pointer;\n"])));
export var rightIconStyle = css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 9;\n"], ["\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 9;\n"])));
export var leftIconStyle = css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  position: absolute;\n  left: 0;\n  top: 0;\n  z-index: 9;\n"], ["\n  position: absolute;\n  left: 0;\n  top: 0;\n  z-index: 9;\n"])));
/**
 * @example
 * <InputWrapper>
 *    <Input pl="2.2rem" />
 *    <LeftIconButton>{Icon}</LeftIconButton>
 * </InputWrapper>
 */
export var LeftIconButton = styled(IconButton)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), leftIconStyle);
/**
 * @example
 * <InputWrapper>
 *  <Input pr="2.2rem" />
 *  <RightIconButton>{Icon}</LeftIconButton>
 * </InputWrapper>
 */
export var RightIconButton = styled(IconButton)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), rightIconStyle);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=IconInput.js.map